module.exports = __webpack_public_path__ + "static/media/commit-main-phone.bee5084a.png";